export const RADIUS_DEFAULT_METERS = 2;
export const RADIUS_MIN_METERS = 0.5;
export const RADIUS_MAX_METERS = 50;
export const RADIUS_STEP_METERS = 0.5;

export const getStationColor = (category) => {
  const colorMap = {
    定位基站: {
      primary: "#1890ff",
      light: "#e6f7ff",
      border: "#91d5ff",
      background: "rgba(24, 144, 255, 0.85)",
    },
    防護區: {
      primary: "#fa8c16",
      light: "#fff7e6",
      border: "#ffd591",
      background: "rgba(250, 140, 22, 0.85)",
    },
    其他基站: {
      primary: "#52c41a",
      light: "#f6ffed",
      border: "#b7eb8f",
      background: "rgba(82, 196, 26, 0.85)",
    },
  };
  return (
    colorMap[category] || {
      primary: "#8c8c8c",
      light: "#fafafa",
      border: "#d9d9d9",
      background: "rgba(140, 140, 140, 0.85)",
    }
  );
};
